<app-card
  class="flex-basis-100 mb-12"
  *ngIf="metadata?.policyHolder || originalMetadata?.policyHolder"
>
  <div cardTitle i18n>Personne assurée</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.sex || originalMetadata?.policyHolder?.sex
        "
      >
        <span class="card__label" i18n>Genre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.policyHolder?.sex,
            }"
            >{{ getSexEnumLabel(metadata?.policyHolder?.sex!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.sex &&
              originalMetadata?.policyHolder?.sex !== metadata.policyHolder?.sex
            "
            >{{ getSexEnumLabel(originalMetadata?.policyHolder?.sex!) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.nationality ||
          originalMetadata?.policyHolder?.nationality
        "
      >
        <span class="card__value card__label" i18n>Nationalité</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.policyHolder?.nationality,
            }"
            *ngIf="metadata?.policyHolder?.nationality"
            >{{ nationalities[metadata?.policyHolder?.nationality!].fr }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.nationality &&
              originalMetadata?.policyHolder?.nationality !==
                metadata.policyHolder?.nationality
            "
            >{{
              nationalities[originalMetadata?.policyHolder?.nationality!].fr
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.licenseObtentionDate ||
          originalMetadata?.policyHolder?.licenseObtentionDate
        "
      >
        <span class="card__value card__label" i18n
          >Date d'obtention du permis</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.policyHolder?.licenseObtentionDate,
            }"
            >{{ metadata.policyHolder?.licenseObtentionDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.licenseObtentionDate &&
              originalMetadata?.policyHolder?.licenseObtentionDate !==
                metadata.policyHolder?.licenseObtentionDate
            "
            >{{ originalMetadata?.policyHolder?.licenseObtentionDate }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.birthDate ||
          originalMetadata?.policyHolder?.birthDate
        "
      >
        <span class="card__value card__label" i18n>Date de naissance</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.policyHolder?.birthDate,
            }"
            >{{ metadata.policyHolder?.birthDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.birthDate &&
              originalMetadata?.policyHolder?.birthDate !==
                metadata.policyHolder?.birthDate
            "
            >{{ originalMetadata?.policyHolder?.birthDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.npa || originalMetadata?.policyHolder?.npa
        "
      >
        <span class="card__value card__label" i18n>NPA</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.policyHolder?.npa,
            }"
            >{{ metadata.policyHolder?.npa }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.npa &&
              originalMetadata?.policyHolder?.npa !== metadata.policyHolder?.npa
            "
            >{{ originalMetadata?.policyHolder?.npa }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    metadata?.policyHolder?.mainDriver ||
    originalMetadata?.policyHolder?.mainDriver
  "
>
  <div cardTitle i18n>Conducteur principal</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.mainDriver?.sex ||
          originalMetadata?.policyHolder?.mainDriver?.sex
        "
      >
        <span class="card__label" i18n>Genre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.policyHolder?.mainDriver?.sex,
            }"
            >{{
              getSexEnumLabel(metadata.policyHolder?.mainDriver?.sex!)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.mainDriver?.sex &&
              originalMetadata?.policyHolder?.mainDriver?.sex !==
                metadata.policyHolder?.mainDriver?.sex
            "
            >{{
              getSexEnumLabel(originalMetadata?.policyHolder?.mainDriver?.sex!)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.mainDriver?.nationality ||
          originalMetadata?.policyHolder?.mainDriver?.nationality
        "
      >
        <span class="card__value card__label" i18n>Nationalité</span>
        <div class="d-flex gap-2 flex-column">
          <span
            *ngIf="metadata?.policyHolder?.mainDriver?.nationality"
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.policyHolder?.mainDriver?.nationality,
            }"
            >{{
              nationalities[metadata?.policyHolder?.mainDriver?.nationality!].fr
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.mainDriver?.nationality &&
              originalMetadata?.policyHolder?.mainDriver?.nationality !==
                metadata.policyHolder?.mainDriver?.nationality
            "
            >{{
              nationalities[
                originalMetadata?.policyHolder?.mainDriver?.nationality!
              ].fr
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.mainDriver?.licenseObtentionDate ||
          originalMetadata?.policyHolder?.mainDriver?.licenseObtentionDate
        "
      >
        <span class="card__value card__label" i18n
          >Date d'obtention du permis</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.policyHolder?.mainDriver
                  ?.licenseObtentionDate,
            }"
            >{{ metadata.policyHolder?.mainDriver?.licenseObtentionDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.mainDriver
                ?.licenseObtentionDate &&
              originalMetadata?.policyHolder?.mainDriver
                ?.licenseObtentionDate !==
                metadata.policyHolder?.mainDriver?.licenseObtentionDate
            "
            >{{
              originalMetadata?.policyHolder?.mainDriver?.licenseObtentionDate
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.mainDriver?.birthDate ||
          originalMetadata?.policyHolder?.mainDriver?.birthDate
        "
      >
        <span class="card__value card__label" i18n>Date de naissance</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.policyHolder?.mainDriver?.birthDate,
            }"
            >{{ metadata.policyHolder?.mainDriver?.birthDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.mainDriver?.birthDate &&
              originalMetadata?.policyHolder?.mainDriver?.birthDate !==
                metadata.policyHolder?.mainDriver?.birthDate
            "
            >{{ originalMetadata?.policyHolder?.mainDriver?.birthDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.policyHolder?.mainDriver?.npa ||
          originalMetadata?.policyHolder?.mainDriver?.npa
        "
      >
        <span class="card__value card__label" i18n>NPA</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.policyHolder?.mainDriver?.npa,
            }"
            >{{ metadata?.policyHolder?.npa }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.policyHolder?.mainDriver?.npa &&
              originalMetadata?.policyHolder?.mainDriver?.npa !==
                metadata.policyHolder?.mainDriver?.npa
            "
            >{{ originalMetadata?.policyHolder?.mainDriver?.npa }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations véhicule</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.requestType || originalMetadata?.requestType"
      >
        <span class="card__label" i18n>Il s'agit de</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.requestType,
            }"
            >{{ getVehicleRequestTypeLabel(metadata.requestType) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.requestType &&
              originalMetadata?.requestType !== metadata.requestType
            "
            >{{
              getVehicleRequestTypeLabel(originalMetadata.requestType)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.vehicle?.certificateId ||
          originalMetadata?.vehicle?.certificateId
        "
      >
        <span class="card__value card__label" i18n>Numéro d'homologation</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.vehicle?.certificateId,
            }"
            >{{ metadata.vehicle?.certificateId }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.vehicle?.certificateId &&
              originalMetadata?.vehicle?.certificateId !==
                metadata.vehicle?.certificateId
            "
            >{{ originalMetadata?.vehicle?.certificateId }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.vehicle?.brand?.name ||
          originalMetadata?.vehicle?.brand?.name
        "
      >
        <span class="card__value card__label" i18n>Marque</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.vehicle?.brand?.name,
            }"
            >{{ metadata.vehicle?.brand?.name }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.vehicle?.brand?.name &&
              originalMetadata?.vehicle?.brand?.name !==
                metadata.vehicle?.brand?.name
            "
            >{{ originalMetadata?.vehicle?.brand?.name }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.distance || originalMetadata?.distance"
      >
        <span class="card__value card__label" i18n>Distance par an</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.distance,
            }"
            >{{ getVehicleDistanceLabel(metadata.distance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.distance &&
              originalMetadata?.distance !== metadata.distance
            "
            >{{ getVehicleDistanceLabel(originalMetadata?.distance!) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.parkingArea || originalMetadata?.parkingArea"
      >
        <span class="card__value card__label" i18n>Lieu de stationnement</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.parkingArea,
            }"
            >{{ metadata.parkingArea }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.parkingArea &&
              originalMetadata?.parkingArea !== metadata.parkingArea
            "
            >{{ originalMetadata?.parkingArea }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.vehicle?.firstImmatriculationDate ||
          originalMetadata?.vehicle?.firstImmatriculationDate
        "
      >
        <span class="card__value card__label" i18n
          >1ère mise en circulation</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.vehicle?.firstImmatriculationDate,
            }"
            >{{ metadata.vehicle?.firstImmatriculationDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.vehicle?.firstImmatriculationDate &&
              originalMetadata?.vehicle?.firstImmatriculationDate !==
                metadata.vehicle?.firstImmatriculationDate
            "
            >{{ originalMetadata?.vehicle?.firstImmatriculationDate }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.vehicle?.immatriculation ||
          originalMetadata?.vehicle?.immatriculation
        "
      >
        <span class="card__value card__label" i18n
          >Numéro d'immatriculation</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.vehicle?.immatriculation,
            }"
            >{{ metadata.vehicle?.immatriculation }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.vehicle?.immatriculation &&
              originalMetadata?.vehicle?.immatriculation !==
                metadata.vehicle?.immatriculation
            "
            >{{ originalMetadata?.vehicle?.immatriculation }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.vehicle?.model || originalMetadata?.vehicle?.model"
      >
        <span class="card__value card__label" i18n>Modèle</span>
        <div class="d-flex gap-2 flex-column strong-text">
          <div
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.vehicle?.model,
            }"
          >
            <span>{{ metadata?.vehicle?.model?.modelName }}</span
            ><small class="text-muted ms-2">{{
              metadata?.vehicle?.model?.transmission +
                ' - ' +
                metadata?.vehicle?.model?.power +
                'CV - ' +
                metadata?.vehicle?.model?.fuel +
                ' - ' +
                metadata?.vehicle?.model?.body +
                ' - ' +
                metadata?.vehicle?.model?.doors +
                ' portes'
            }}</small>
          </div>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.vehicle?.model &&
              !carModelsEqual(
                originalMetadata?.vehicle?.model,
                metadata.vehicle?.model
              )
            "
          >
            <span>{{ originalMetadata?.vehicle?.model?.modelName }}</span
            ><small class="text-muted ms-2">{{
              originalMetadata?.vehicle?.model?.transmission +
                ' - ' +
                originalMetadata?.vehicle?.model?.power +
                'CV - ' +
                originalMetadata?.vehicle?.model?.fuel +
                ' - ' +
                originalMetadata?.vehicle?.model?.body +
                ' - ' +
                originalMetadata?.vehicle?.model?.doors +
                ' portes'
            }}</small></span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.mainUse || originalMetadata?.mainUse"
      >
        <span class="card__value card__label" i18n>Utilisation principale</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.mainUse,
            }"
            >{{ getVehicleUseLabel(metadata.mainUse) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.mainUse &&
              originalMetadata?.mainUse !== metadata.mainUse
            "
            >{{ getVehicleUseLabel(originalMetadata?.mainUse!) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.garage || originalMetadata?.garage"
      >
        <span class="card__value card__label" i18n>Garage</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.garage,
            }"
            >{{ getVehicleGarageLabel(metadata.garage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.garage &&
              originalMetadata?.garage !== metadata.garage
            "
            >{{ getVehicleGarageLabel(originalMetadata?.garage!) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.leasing !== null && metadata?.leasing !== undefined) ||
          (originalMetadata?.leasing !== null &&
            originalMetadata?.leasing !== undefined)
        "
      >
        <span class="card__value card__label" i18n>Leasing ?</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.leasing === null ||
                  originalMetadata.leasing === undefined),
            }"
            >{{ getBooleanLabel(metadata.leasing) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.leasing &&
              originalMetadata?.leasing !== metadata.leasing
            "
            >{{ getBooleanLabel(originalMetadata.leasing) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.leasingCompany || originalMetadata?.leasingCompany"
      >
        <span class="card__value card__label" i18n>Entreprise de leasing</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.leasingCompany,
            }"
            >{{ metadata.leasingCompany }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.leasingCompany &&
              originalMetadata?.leasingCompany !== metadata.leasingCompany
            "
            >{{ originalMetadata?.leasingCompany }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations assurance désirée</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.insuranceStartDate || originalMetadata?.insuranceStartDate
        "
      >
        <span class="card__label" i18n>Date de début d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.insuranceStartDate,
            }"
            >{{ metadata.insuranceStartDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.insuranceStartDate &&
              originalMetadata?.insuranceStartDate !==
                metadata.insuranceStartDate
            "
            >{{ originalMetadata?.insuranceStartDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.covers?.prestations &&
            metadata?.covers?.prestations?.length! > 0) ||
          (originalMetadata?.covers?.prestations &&
            originalMetadata?.covers?.prestations?.length! > 0)
        "
      >
        <span class="card__value card__label" i18n>Couvertures</span>
        <div class="d-flex gap-2 flex-column">
          <span
            ><ng-container
              *ngFor="
                let prestation of metadata?.covers?.prestations;
                let last = last
              "
              ><span
                [ngClass]="{
                  'new-lead-value':
                    originalMetadata &&
                    !originalMetadata?.covers?.prestations?.includes(
                      prestation
                    ),
                }"
                >{{ getVehiclePrestationLabel(prestation) }}</span
              ><ng-container *ngIf="!last">, </ng-container></ng-container
            ></span
          >
          <span
            class="old-lead-value"
            *ngIf="originalMetadata?.covers?.prestations?.length! > 0"
            ><ng-container
              *ngFor="
                let prestation of originalMetadata?.covers?.prestations;
                let last = last
              "
              ><ng-container
                *ngIf="!metadata?.covers?.prestations?.includes(prestation)"
                >{{ getVehiclePrestationLabel(prestation)
                }}<ng-container *ngIf="!last">, </ng-container></ng-container
              ></ng-container
            ></span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.insurersToCompare || originalMetadata?.insurersToCompare
        "
      >
        <span class="card__label" i18n>Assureurs à comparer</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.insurersToCompare,
            }"
          >
            <ng-container
              *ngFor="
                let insurer of metadata?.insurersToCompare;
                let isLast = last
              "
              >{{ getCentralisationInsurerLabel(insurer) }}
              {{ isLast ? '' : ', ' }}</ng-container
            >
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.insurersToCompare &&
              originalMetadata?.insurersToCompare !== metadata.insurersToCompare
            "
          >
            <ng-container
              *ngFor="
                let insurer of originalMetadata?.insurersToCompare;
                let isLast = last
              "
              >{{ getCentralisationInsurerLabel(insurer) }}
              {{ isLast ? '' : ', ' }}</ng-container
            >
          </span>
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.covers?.collisionDeductible ||
          originalMetadata?.covers?.collisionDeductible
        "
      >
        <span class="card__value card__label" i18n>Franchise casco totale</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.covers?.collisionDeductible,
            }"
            >{{ metadata.covers?.collisionDeductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.covers?.collisionDeductible &&
              originalMetadata?.covers?.collisionDeductible !==
                metadata.covers?.collisionDeductible
            "
            >{{ originalMetadata?.covers?.collisionDeductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.covers?.partialCoverDeductible ||
          originalMetadata?.covers?.partialCoverDeductible
        "
      >
        <span class="card__value card__label" i18n
          >Franchise casco partielle</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.covers?.partialCoverDeductible,
            }"
            >{{ metadata.covers?.partialCoverDeductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.covers?.partialCoverDeductible &&
              originalMetadata?.covers?.partialCoverDeductible !==
                metadata.covers?.partialCoverDeductible
            "
            >{{ originalMetadata?.covers?.partialCoverDeductible }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.covers?.personalBelongingsValue ||
          originalMetadata?.covers?.personalBelongingsValue
        "
      >
        <span class="card__value card__label" i18n
          >Couvertures effets personnelles</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.covers?.personalBelongingsValue,
            }"
            >{{ metadata.covers?.personalBelongingsValue }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.covers?.personalBelongingsValue &&
              originalMetadata?.covers?.personalBelongingsValue !==
                metadata.covers?.personalBelongingsValue
            "
            >{{ originalMetadata?.covers?.personalBelongingsValue }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayContractualQuestions(metadata) ||
    displayContractualQuestions(originalMetadata)
  "
>
  <div cardTitle i18n>Questions contractuelles</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.isInsured !== null && metadata?.isInsured !== undefined) ||
          (originalMetadata?.isInsured !== null &&
            originalMetadata?.isInsured !== undefined)
        "
      >
        <span class="card__label" i18n>A déjà été assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.isInsured === null ||
                  originalMetadata.isInsured === undefined),
            }"
            >{{ getBooleanLabel(metadata.isInsured) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.isInsured &&
              originalMetadata?.isInsured !== metadata.isInsured
            "
            >{{ getBooleanLabel(originalMetadata.isInsured) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.replaceContract !== null &&
            metadata?.replaceContract !== undefined) ||
          (originalMetadata?.replaceContract !== null &&
            originalMetadata?.replaceContract !== undefined)
        "
      >
        <span class="card__value card__label" i18n
          >Ce contrat remplace le précédent</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.replaceContract === null ||
                  originalMetadata.replaceContract === undefined),
            }"
            >{{ getBooleanLabel(metadata.replaceContract) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.replaceContract &&
              originalMetadata?.replaceContract !== metadata.replaceContract
            "
            >{{ getBooleanLabel(originalMetadata.replaceContract) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.oldCompany || originalMetadata?.oldCompany"
      >
        <span class="card__value card__label" i18n>Ancien assureur</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.oldCompany,
            }"
            >{{ metadata.oldCompany }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.oldCompany &&
              originalMetadata?.oldCompany !== metadata.oldCompany
            "
            >{{ originalMetadata?.oldCompany }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasAlreadyTakenDamage !== null &&
            metadata?.hasAlreadyTakenDamage !== undefined) ||
          (originalMetadata?.hasAlreadyTakenDamage !== null &&
            originalMetadata?.hasAlreadyTakenDamage !== undefined)
        "
      >
        <span class="card__value card__label" i18n>A déjà subi un dommage</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.hasAlreadyTakenDamage === null ||
                  originalMetadata.hasAlreadyTakenDamage === undefined),
            }"
            >{{ getBooleanLabel(metadata.hasAlreadyTakenDamage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasAlreadyTakenDamage &&
              originalMetadata?.hasAlreadyTakenDamage !==
                metadata.hasAlreadyTakenDamage
            "
            >{{ getBooleanLabel(originalMetadata.hasAlreadyTakenDamage) }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasAlreadyLostLicense !== null &&
            metadata?.hasAlreadyLostLicense !== undefined) ||
          (originalMetadata?.hasAlreadyLostLicense !== null &&
            originalMetadata?.hasAlreadyLostLicense !== undefined)
        "
      >
        <span class="card__value card__label" i18n
          >A déjà eu un retrait de permis</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.hasAlreadyLostLicense === null ||
                  originalMetadata.hasAlreadyLostLicense === undefined),
            }"
            >{{ getBooleanLabel(metadata.hasAlreadyLostLicense) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasAlreadyLostLicense &&
              originalMetadata?.hasAlreadyLostLicense !==
                metadata.hasAlreadyLostLicense
            "
            >{{ getBooleanLabel(originalMetadata.hasAlreadyLostLicense) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.lostLicenseDate || originalMetadata?.lostLicenseDate"
      >
        <span class="card__value card__label" i18n
          >Date de retrait de permis</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.lostLicenseDate,
            }"
            >{{ metadata.lostLicenseDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.lostLicenseDate &&
              originalMetadata?.lostLicenseDate !== metadata.lostLicenseDate
            "
            >{{ originalMetadata?.lostLicenseDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.lostLicenseReason || originalMetadata?.lostLicenseReason
        "
      >
        <span class="card__value card__label" i18n
          >Cause retrait de permis</span
        >
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.lostLicenseReason,
            }"
            >{{ metadata.lostLicenseReason }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.lostLicenseReason &&
              originalMetadata?.lostLicenseReason !== metadata.lostLicenseReason
            "
            >{{ originalMetadata?.lostLicenseReason }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.damageDescription || originalMetadata?.damageDescription
        "
      >
        <span class="card__value card__label" i18n>Description du dommage</span>
        <div class="d-flex gap-2 flex-column">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.damageDescription,
            }"
            >{{ metadata.damageDescription }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.damageDescription &&
              originalMetadata?.damageDescription !== metadata.damageDescription
            "
            >{{ originalMetadata?.damageDescription }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
<app-card
  class="flex-basis-100 mb-12"
  *ngIf="metadata?.chosenSupplementaryOffers?.length"
>
  <div cardTitle i18n>Options supplémentaires</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngFor="let option of metadata.chosenSupplementaryOffers"
      >
        <span class="card__label">{{ option.productNames?.[0] }}</span>
        <span class="card__value">{{ option.price }} CHF</span>
      </div>
    </div>
  </div>
</app-card>
